import style from '../request-equipment-service.module.scss';
import { useTranslations } from 'next-intl';
import { RequestServiceLoaderDesktop } from './request-service-loader-desktop';
import { RequestServiceLoaderMobile } from './request-service-loader-mobile';

const RequestEquipmentServiceSearchLoader = () => {
  const t = useTranslations();
  return (
    <div className="p-3">
      <div className="d-none d-md-block">
        <RequestServiceLoaderDesktop
          dateLabel={t('REQUEST_SERVICE_DATE')}
          contactLabel={t('REQUEST_SERVICE_CONTACT')}
        />
      </div>
      <div className="d-md-none">
        <RequestServiceLoaderMobile
          className={style['request-service__show-input__rectangle-dot']}
        />
      </div>
    </div>
  );
};
export default RequestEquipmentServiceSearchLoader;
